/* ==========================================================================
   Next10 — rodízio da barra de anúncio
   Par de assets/n10-announcement.css, usado por sections/n10-announcement.liquid.

   A seção só carrega este arquivo quando há MAIS DE UMA mensagem: com uma
   mensagem só (o caso recomendado para conversão) a barra é HTML puro, sem
   JS nenhum.

   Mesmos cuidados do rodízio da faixa de vantagens (n10-vantagens.js):
   - não roda com prefers-reduced-motion: reduce (fica na primeira mensagem)
   - aguenta a seção aparecer mais de uma vez na mesma página
   - o script pode ser incluído duas vezes: a segunda execução sai na hora
   - pausa com a aba em segundo plano e com o ponteiro sobre a barra
     (quem está lendo não perde a frase no meio)
   - reage ao editor de tema (shopify:section:load / :unload)
   ========================================================================== */

(function () {
  'use strict';

  if (window.n10AnuncioReady) return;
  window.n10AnuncioReady = true;

  var ITEM = 'n10-anuncio__item';
  var mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var rotators = [];

  function Rotator(list) {
    var self = this;

    this.list = list;
    this.items = [];
    this.index = 0;
    this.timer = null;
    this.active = false;

    var intervalo = parseInt(list.getAttribute('data-n10-anuncio'), 10);
    this.interval = intervalo > 0 ? intervalo : 5000;

    for (var i = 0; i < list.children.length; i++) {
      if (list.children[i].classList.contains(ITEM)) this.items.push(list.children[i]);
    }

    this.next = function () {
      if (!self.items.length) return;
      self.items[self.index].classList.remove('is-active');
      self.index = (self.index + 1) % self.items.length;
      self.items[self.index].classList.add('is-active');
    };

    this.onEnter = function () {
      self.pause();
    };
    this.onLeave = function () {
      if (!document.hidden) self.play();
    };

    // pausa no hover e no foco de teclado: mensagem com link não pode sumir
    // debaixo do cursor nem do foco de quem navega por tab
    list.addEventListener('mouseenter', this.onEnter);
    list.addEventListener('mouseleave', this.onLeave);
    list.addEventListener('focusin', this.onEnter);
    list.addEventListener('focusout', this.onLeave);
  }

  Rotator.prototype.destroy = function () {
    this.disable();
    this.list.removeEventListener('mouseenter', this.onEnter);
    this.list.removeEventListener('mouseleave', this.onLeave);
    this.list.removeEventListener('focusin', this.onEnter);
    this.list.removeEventListener('focusout', this.onLeave);
  };

  Rotator.prototype.enable = function () {
    if (this.active || this.items.length < 2) return;
    this.active = true;
    this.index = 0;
    for (var i = 0; i < this.items.length; i++) {
      this.items[i].classList.toggle('is-active', i === 0);
    }
    // a classe no container é o sinal para o CSS assumir o modo rodízio
    this.list.classList.add('is-rotating');
    this.play();
  };

  Rotator.prototype.disable = function () {
    this.pause();
    if (!this.active) return;
    this.active = false;
    this.list.classList.remove('is-rotating');
    for (var i = 0; i < this.items.length; i++) {
      this.items[i].classList.remove('is-active');
    }
  };

  Rotator.prototype.play = function () {
    if (!this.active || this.timer) return;
    this.timer = window.setInterval(this.next, this.interval);
  };

  Rotator.prototype.pause = function () {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  };

  function sync() {
    for (var i = 0; i < rotators.length; i++) {
      if (mqReduced.matches) {
        rotators[i].disable();
      } else {
        rotators[i].enable();
      }
    }
  }

  function collect() {
    for (var i = 0; i < rotators.length; i++) rotators[i].destroy();
    rotators = [];

    var lists = document.querySelectorAll('[data-n10-anuncio]');
    for (var j = 0; j < lists.length; j++) rotators.push(new Rotator(lists[j]));

    sync();
  }

  function onVisibilityChange() {
    for (var i = 0; i < rotators.length; i++) {
      if (document.hidden) {
        rotators[i].pause();
      } else {
        rotators[i].play();
      }
    }
  }

  function listen(mq, handler) {
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handler);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(handler); // Safari < 14
    }
  }

  listen(mqReduced, sync);
  document.addEventListener('visibilitychange', onVisibilityChange);
  document.addEventListener('shopify:section:load', collect);
  document.addEventListener('shopify:section:unload', collect);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }
})();
